// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"3e5cbf61","503":"3e5cbf61","728":"abaa2d81","770":"3e5cbf61","811":"3e5cbf61"}[chunkId] + ".chunk.css";
};